import { object, string } from 'yup';

export const toteAddValidation = () =>
  object().shape({
    name: string().required('Tote is required')
  });
